import { hotelReservationPhase, type HotelReservation } from '@bandido/shared/types';
import { validPoint, type HotelSearchDraft } from './searchModel';

/** Only prefill a fresh search. Never reuse the old acceptance or dispatch a booking. */
export function hotelQuoteRestartDraft(reservation: HotelReservation): HotelSearchDraft | null {
  if (
    !reservation.canDiscardQuote ||
    reservation.bookDispatchState !== 'not_dispatched' ||
    reservation.hotelSnapshot.bookingId ||
    hotelReservationPhase(reservation.hotelSnapshot) !== 'expired'
  )
    return null;
  const snapshot = reservation.hotelSnapshot;
  const { latitude, longitude } = snapshot.location ?? {};
  return {
    location: validPoint(latitude, longitude)
      ? { type: 'point', latitude: latitude!, longitude: longitude!, label: snapshot.propertyName }
      : null,
    checkIn: snapshot.checkIn,
    checkOut: snapshot.checkOut,
    rooms: snapshot.rooms.map((room) => ({ paxes: [...Array(room.adults).fill(30), ...room.children_ages] })),
    radiusKm: 10,
    nationality: 'UY',
    results: { name: snapshot.propertyName },
  };
}
